import { render, staticRenderFns } from "./SendAddress.vue?vue&type=template&id=6dc315d8&scoped=true"
import script from "./SendAddress.vue?vue&type=script&lang=js"
export * from "./SendAddress.vue?vue&type=script&lang=js"
import style0 from "./SendAddress.vue?vue&type=style&index=0&id=6dc315d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc315d8",
  null
  
)

export default component.exports